export default "__VITE_ASSET__BDcVf_0r__"